var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.875H2.5C1.4375 1.875 0.625 2.6875 0.625 3.75V11.25C0.625 12.3125 1.4375 13.125 2.5 13.125H12.5C13.5625 13.125 14.375 12.3125 14.375 11.25V3.75C14.375 2.6875 13.5625 1.875 12.5 1.875ZM2.50014 3.12494H12.5001C12.7501 3.12494 12.9376 3.24994 13.0626 3.49994L7.50014 7.37494L1.93764 3.49994C2.06264 3.24994 2.25014 3.12494 2.50014 3.12494ZM1.875 11.25C1.875 11.625 2.125 11.875 2.5 11.875H12.5C12.875 11.875 13.125 11.625 13.125 11.25V4.93749L7.875 8.62499C7.75 8.68749 7.625 8.74999 7.5 8.74999C7.375 8.74999 7.25 8.68749 7.125 8.62499L1.875 4.93749V11.25Z",
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6613_31441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 15,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.875H2.5C1.4375 1.875 0.625 2.6875 0.625 3.75V11.25C0.625 12.3125 1.4375 13.125 2.5 13.125H12.5C13.5625 13.125 14.375 12.3125 14.375 11.25V3.75C14.375 2.6875 13.5625 1.875 12.5 1.875ZM2.50014 3.12494H12.5001C12.7501 3.12494 12.9376 3.24994 13.0626 3.49994L7.50014 7.37494L1.93764 3.49994C2.06264 3.24994 2.25014 3.12494 2.50014 3.12494ZM1.875 11.25C1.875 11.625 2.125 11.875 2.5 11.875H12.5C12.875 11.875 13.125 11.625 13.125 11.25V4.93749L7.875 8.62499C7.75 8.68749 7.625 8.74999 7.5 8.74999C7.375 8.74999 7.25 8.68749 7.125 8.62499L1.875 4.93749V11.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6613_31441)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H15V15H0V0Z",
    fill: "#F2F2F2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.34f63030646dbc42d6913a47a8307592.svg";
export { ForwardRef as ReactComponent };